import { Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import ButtonPrimary from "./ButtonPrimary";
import COLORS from '../styles/colors.json';

const STYLE = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: COLORS.white,
    borderRadius: 2
};

export default function ConversionError({ data, error, handleButtonClick }) {

    const quoteId = error.quote.quote_id;
    const message = `Unable to create a workorder for quote #${quoteId}`;
    
    return (
        <Box sx={STYLE} >
            <Box
                borderBottom={1}
                borderColor={COLORS.gray3}
                padding={1}
            >
                <h3>Unable to convert quote</h3>
            </Box>
            <div className="modal-content" >
                <Box fontSize={50} marginRight={2}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                </Box>
                {message}
            </div>
            <Box
                padding={1}
                display='flex'
                justifyContent='flex-end'
            >
                <ButtonPrimary onClick={handleButtonClick}>
                    OK
                </ButtonPrimary>
            </Box>
        </Box>
    )
}
